import { combineReducers, configureStore } from '@reduxjs/toolkit';
import {
    persistStore,
    persistReducer,
    FLUSH,
    REHYDRATE,
    PAUSE,
    PERSIST,
    PURGE,
    REGISTER,
} from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import { userReducer } from './userRelated/userSlice';
import { studentReducer } from './studentRelated/studentSlice';
import { noticeReducer } from './noticeRelated/noticeSlice';
import { sclassReducer } from './sclassRelated/sclassSlice';
import { teacherReducer } from './teacherRelated/teacherSlice';
import { teacherToolsReducer } from './teacherRelated/teacherToolsSlice';
import { complainReducer } from './complainRelated/complainSlice';
import { feeReducer } from './feeRelated/feeSlice';
import { expenseReducer } from './expenseRelated/expenseSlice';
import { schemeReducer } from './schemeRelated/schemeSlice';
import { schoolPageReducer } from './schoolPageRelated/schoolPageSlice';

const rootReducer = combineReducers({
    user: userReducer,
    student: studentReducer,
    teacher: teacherReducer,
    teacherTools: teacherToolsReducer,
    notice: noticeReducer,
    complain: complainReducer,
    sclass: sclassReducer,
    fee: feeReducer,
    expense: expenseReducer,
    scheme: schemeReducer,
    schoolPage: schoolPageReducer,
});

const persistConfig = {
    key: 'sms-root',
    storage,
    whitelist: ['user'],
};

const persistedReducer = persistReducer(persistConfig, rootReducer);

export const store = configureStore({
    reducer: persistedReducer,
    middleware: (getDefaultMiddleware) =>
        getDefaultMiddleware({
            serializableCheck: {
                ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
            },
        }),
});

export const persistor = persistStore(store);

export default store;
